/* Program Name: validationFunctions.js
 **  Description: file containing various functions for form validation
 **
 **
 ** Project    Date        Who  Comments
 ** ---------  ----------  ---  ---------------------------------------------------
 ** IS0200241  2021-06-24  STT  Initial program
 ** SD9567     2025-03-21  sgs  Added meetsThreshold validation
 ** SD9567    2025-04-16  sgs  SD9681 - CLV: Inventory Maintenance
 *********************************************************************************/

/** Confirm Errors
 * @param tempError - an object that contains error messages and related data field
 *                    if empty then there are no errors
 * returns wether or not there are errors on the form
 */
export const confirmErrors = (tempError) => {
  var errors = false
  for (const e of Object.entries(tempError)) {
    if (e[1] !== false) {
      errors = true
    }
  }
  if (errors) {
    return false
  } else {
    return true
  }
}

/** Required Field
 * @param field - the name of the field that is being validated
 * returns a message if there is an error or false if there is none
 */
export const requiredField = (field) => {
  return field ? false : 'This field is required.'
}

/** Meets Threshold
 * @param field - the name of the field that is being validated
 * returns a message if there is an error or false if there is none
 * 
 * @param threshold - the integer amount that the field value
 * must be above. returns a message if there is an error or 
 * false if there is none
 */
export const meetsThreshold = (field, threshold) => {
  if (isNaN(field) || field < threshold) {
    return `value must be greater than or equal to ${threshold}`
  }

  return false
}

/** Required Email
 * @param field - the name of the field that is being validated
 * returns a message if there is an error or false if there is none
 */
export const requiredEmail = (field) => {
  return field
    ? /.+@.+..+/.test(field)
      ? false
      : 'This is not a valid email'
    : 'This field is required'
}
